import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const targetApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getAllTargets: builder.query({
      query: () => ({
        url: "qwikITUserTarget/",
        method: "GET",
      }),
      providesTags: ["targets"],
      transformResponse: response => response,
    }),

    getTargetById: builder.query({
      query: id => ({
        url: `qwikITUserTarget/${id}/`,
        method: "GET",
      }),
      providesTags: ["targets"],
      transformResponse: response => response,
    }),

    createTarget: builder.mutation({
      query: data => ({
        url: "qwikITUserTarget/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["targets"],
      transformResponse: response => {
        toast.success("Target set successfully");
        return response;
      },
    }),

    updateTarget: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `qwikITUserTarget/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["targets"],
      transformResponse: response => {
        toast.success("Target updated successfully");
        return response;
      },
    }),

    deleteTarget: builder.mutation({
      query: id => ({
        url: `qwikITUserTarget/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["targets"],
      transformResponse: response => {
        toast.success("Target deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllTargetsQuery,
  useGetTargetByIdQuery,
  useCreateTargetMutation,
  useUpdateTargetMutation,
  useDeleteTargetMutation,
} = targetApi;

export default targetApi;
